import { RegistryWidgetsType } from '@rjsf/utils';
import { InputCustom, DropdownCustom, CheckboxCustom } from './widgets';

export const customWidgets: RegistryWidgetsType = {
  TextWidget: InputCustom,
  SelectWidget: DropdownCustom,
  CheckboxWidget: CheckboxCustom,
};
